// @flow

import type { Action } from './store.type';

export const INSTALL_APP_REQUEST = 'INSTALL_APP_REQUEST';
type INSTALL_APP_REQUEST_TYPE = 'INSTALL_APP_REQUEST';

export const INSTALL_APP_SUCCESS = 'INSTALL_APP_SUCCESS';
type INSTALL_APP_SUCCESS_TYPE = 'INSTALL_APP_SUCCESS';

export const INSTALL_APP_FAILURE = 'INSTALL_APP_FAILURE';
type INSTALL_APP_FAILURE_TYPE = 'INSTALL_APP_FAILURE';

export const GET_INSTALL_STATUS_REQUEST = 'GET_INSTALL_STATUS_REQUEST';
type GET_INSTALL_STATUS_REQUEST_TYPE = 'GET_INSTALL_STATUS_REQUEST';

export const GET_INSTALL_STATUS_SUCCESS = 'GET_INSTALL_STATUS_SUCCESS';
type GET_INSTALL_STATUS_SUCCESS_TYPE = 'GET_INSTALL_STATUS_SUCCESS';

export const GET_INSTALL_STATUS_FAILURE = 'GET_INSTALL_STATUS_FAILURE';
type GET_INSTALL_STATUS_FAILURE_TYPE = 'GET_INSTALL_STATUS_FAILURE';

export const UPDATE_INSTALLATION_STATUS_REQUEST = 'UPDATE_INSTALLATION_STATUS_REQUEST';
type UPDATE_INSTALLATION_STATUS_REQUEST_TYPE = 'UPDATE_INSTALLATION_STATUS_REQUEST';

export const UPDATE_INSTALLATION_STATUS_SUCCESS = 'UPDATE_INSTALLATION_STATUS_SUCCESS';
type UPDATE_INSTALLATION_STATUS_SUCCESS_TYPE = 'UPDATE_INSTALLATION_STATUS_SUCCESS';

export const UPDATE_INSTALLATION_STATUS_FAILURE = 'UPDATE_INSTALLATION_STATUS_FAILURE';
type UPDATE_INSTALLATION_STATUS_FAILURE_TYPE = 'UPDATE_INSTALLATION_STATUS_FAILURE';

export const UPDATE_INSTALLATION_KYC_STATUS_REQUEST = 'UPDATE_INSTALLATION_KYC_STATUS_REQUEST';
type UPDATE_INSTALLATION_KYC_STATUS_REQUEST_TYPE = 'UPDATE_INSTALLATION_KYC_STATUS_REQUEST';

export const UPDATE_INSTALLATION_KYC_STATUS_SUCCESS = 'UPDATE_INSTALLATION_KYC_STATUS_SUCCESS';
type UPDATE_INSTALLATION_KYC_STATUS_SUCCESS_TYPE = 'UPDATE_INSTALLATION_KYC_STATUS_SUCCESS';

export const UPDATE_INSTALLATION_KYC_STATUS_FAILURE = 'UPDATE_INSTALLATION_KYC_STATUS_FAILURE';
type UPDATE_INSTALLATION_KYC_STATUS_FAILURE_TYPE = 'UPDATE_INSTALLATION_KYC_STATUS_FAILURE';

export const ADD_DEMOGRAPHIC_REQUEST = 'ADD_DEMOGRAPHIC_REQUEST';
type ADD_DEMOGRAPHIC_REQUEST_TYPE = 'ADD_DEMOGRAPHIC_REQUEST';

export const ADD_DEMOGRAPHIC_SUCCESS = 'ADD_DEMOGRAPHIC_SUCCESS';
type ADD_DEMOGRAPHIC_SUCCESS_TYPE = 'ADD_DEMOGRAPHIC_SUCCESS';

export const ADD_DEMOGRAPHIC_FAILURE = 'ADD_DEMOGRAPHIC_FAILURE';
type ADD_DEMOGRAPHIC_FAILURE_TYPE = 'ADD_DEMOGRAPHIC_FAILURE';

export const ALERT_SLOW_INSTALLATION_REQUEST = 'ALERT_SLOW_INSTALLATION_REQUEST';
type ALERT_SLOW_INSTALLATION_REQUEST_TYPE = 'ALERT_SLOW_INSTALLATION_REQUEST';

export const ALERT_SLOW_INSTALLATION_SUCCESS = 'ALERT_SLOW_INSTALLATION_SUCCESS';
type ALERT_SLOW_INSTALLATION_SUCCESS_TYPE = 'ALERT_SLOW_INSTALLATION_SUCCESS';

export const ALERT_SLOW_INSTALLATION_FAILURE = 'ALERT_SLOW_INSTALLATION_FAILURE';
type ALERT_SLOW_INSTALLATION_FAILURE_TYPE = 'ALERT_SLOW_INSTALLATION_FAILURE';

export const LOG_APP_CONFIGURATION_REQUEST = 'LOG_APP_CONFIGURATION_REQUEST';
type LOG_APP_CONFIGURATION_REQUEST_TYPE = 'LOG_APP_CONFIGURATION_REQUEST';

export const LOG_APP_CONFIGURATION_SUCCESS = 'LOG_APP_CONFIGURATION_SUCCESS';
type LOG_APP_CONFIGURATION_SUCCESS_TYPE = 'LOG_APP_CONFIGURATION_SUCCESS';

export const LOG_APP_CONFIGURATION_FAILURE = 'LOG_APP_CONFIGURATION_FAILURE';
type LOG_APP_CONFIGURATION_FAILURE_TYPE = 'LOG_APP_CONFIGURATION_FAILURE';

export const CHECKED_SHOW_ONBOARDING_PLAN = 'CHECKED_SHOW_ONBOARDING_PLAN';
export const STORE_STATE_SETUP_THEME = 'STORE_STATE_SETUP_THEME';

type AddDemographicSuccess = {
  data: Object
};

type AddDemographicFailure = {
  error: any
};

type InstallAppSuccess = {
  data: {
    code: string,
    shop: string,
    message: string
  }
};

type GetInstallStatusSuccess = {
  data: {
    code: string,
    shop: string,
    message: string
  }
};

type InstallAppFailure = {
  error: any
};

type InstallAppRequestAction = Action<INSTALL_APP_REQUEST_TYPE, null>;

type InstallAppSuccessAction = Action<INSTALL_APP_SUCCESS_TYPE, InstallAppSuccess>;

type InstallAppFailureAction = Action<INSTALL_APP_FAILURE_TYPE, InstallAppFailure>;

type AddDemographicRequestAction = Action<ADD_DEMOGRAPHIC_REQUEST_TYPE, null>;

type AddDemographicSuccessAction = Action<ADD_DEMOGRAPHIC_SUCCESS_TYPE, AddDemographicSuccess>;

type AddDemographicFailureAction = Action<ADD_DEMOGRAPHIC_FAILURE_TYPE, AddDemographicFailure>;

type AlertSlowInstallationRequestAction = Action<ALERT_SLOW_INSTALLATION_REQUEST_TYPE, null>;

type AlertSlowInstallationSuccessAction = Action<
  ALERT_SLOW_INSTALLATION_SUCCESS_TYPE,
  AddDemographicSuccess
>;

type AlertSlowInstallationFailureAction = Action<
  ALERT_SLOW_INSTALLATION_FAILURE_TYPE,
  AddDemographicFailure
>;

type GetInstallStatusRequestAction = Action<GET_INSTALL_STATUS_REQUEST_TYPE, null>;

type GetInstallStatusSuccessAction = Action<
  GET_INSTALL_STATUS_SUCCESS_TYPE,
  GetInstallStatusSuccess
>;

type GetInstallStatusFailureAction = Action<GET_INSTALL_STATUS_FAILURE_TYPE, InstallAppFailure>;

type UpdateInstallationStatusRequestAction = Action<UPDATE_INSTALLATION_STATUS_REQUEST_TYPE, null>;

type UpdateInstallationStatusSuccessAction = Action<UPDATE_INSTALLATION_STATUS_SUCCESS_TYPE, null>;

type UpdateInstallationStatusFailureAction = Action<
  UPDATE_INSTALLATION_STATUS_FAILURE_TYPE,
  InstallAppFailure
>;

type UpdateKYCStatusRequestAction = Action<UPDATE_INSTALLATION_KYC_STATUS_REQUEST_TYPE, null>;

type UpdateKYCStatusSuccessAction = Action<UPDATE_INSTALLATION_KYC_STATUS_SUCCESS_TYPE, null>;

type UpdateKYCStatusFailureAction = Action<
  UPDATE_INSTALLATION_KYC_STATUS_FAILURE_TYPE,
  InstallAppFailure
>;

type LogAppConfigurationRequestAction = Action<LOG_APP_CONFIGURATION_REQUEST_TYPE, null>;

type LogAppConfigurationSuccessAction = Action<LOG_APP_CONFIGURATION_SUCCESS_TYPE, AppConfigurationSuccess>;

type LogAppConfigurationFailureAction = Action<LOG_APP_CONFIGURATION_FAILURE_TYPE, AppConfigurationFailure>;

type KYCValue = {
  features: Array<string>,
  industries: Array<string>,
  revenue: string
};

export type InstallAction =
  | InstallAppRequestAction
  | InstallAppSuccessAction
  | InstallAppFailureAction
  | AddDemographicRequestAction
  | AddDemographicSuccessAction
  | AddDemographicFailureAction
  | GetInstallStatusRequestAction
  | GetInstallStatusSuccessAction
  | GetInstallStatusFailureAction
  | AlertSlowInstallationRequestAction
  | AlertSlowInstallationSuccessAction
  | AlertSlowInstallationFailureAction
  | UpdateInstallationStatusRequestAction
  | UpdateInstallationStatusSuccessAction
  | UpdateInstallationStatusFailureAction
  | UpdateKYCStatusRequestAction
  | UpdateKYCStatusSuccessAction
  | UpdateKYCStatusFailureAction
  | LogAppConfigurationRequestAction
  | LogAppConfigurationSuccessAction
  | LogAppConfigurationFailureAction;

export type InstallState = {
  loading: boolean,
  success: boolean,
  error: any,
  code: string,
  shop: string,
  message: string,
  installStatus: string,
  installSyncPercent: number,
  installSetupThemePercent: number,
  installStep: number,
  installTotal: number,
  installCurrentStep: number,
  installThemeId: string,
  installThemeName: string,
  kycData: KYCValue
};
